export default __webpack_public_path__ + "static/char-list-pic-02-0bca8772080f9847b6183f6ad2ff869f.png";